var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.form.charterFlightOrCharterVessel === 1,
            expression: "form.charterFlightOrCharterVessel === 1"
          }
        ],
        staticStyle: { "margin-bottom": "10px", height: "100%" }
      },
      [
        _c(
          "div",
          { staticStyle: { float: "right", "margin-bottom": "5px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "1", type: "primary" },
                on: { click: _vm.onCostAdd }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
            ),
            _c(
              "el-button",
              {
                attrs: { no: "2", type: "danger" },
                on: { click: _vm.onCostDel }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
            )
          ],
          1
        ),
        _c("cargo-ag-grid", {
          staticStyle: { height: "100%" },
          attrs: {
            no: "3",
            "config-module": "150010",
            "grid-options": _vm.costGrid.gridOptions,
            "column-defs": _vm.costGridColumnDefs,
            "row-data": _vm.costGrid.rowData
          },
          on: {
            gridReady: function(params) {
              _vm.costGrid.gridApi = params.api
            }
          }
        })
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.form.charterFlightOrCharterVessel === 2,
            expression: "form.charterFlightOrCharterVessel === 2"
          }
        ],
        staticStyle: { "margin-bottom": "10px", height: "100%" }
      },
      [
        _c(
          "cargo-left-right-resize",
          {
            staticStyle: { "min-height": "100%" },
            attrs: {
              "left-style": { width: "30%" },
              "right-style": { width: "70%" }
            }
          },
          [
            _c(
              "template",
              { slot: "left" },
              [
                _c(
                  "div",
                  { staticStyle: { float: "right", margin: "10px 0px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "4", type: "primary" },
                        on: { click: _vm.onAirplaneContainerAdd }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "5", type: "danger" },
                        on: { click: _vm.onAirplaneContainerDel }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                    )
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  staticStyle: { height: "100%" },
                  attrs: {
                    no: "6",
                    "config-module": "150011",
                    "grid-options": _vm.airplaneContainerGrid.gridOptions,
                    "column-defs": _vm.airplaneContainerGrid.columnDefs,
                    "row-data": _vm.airplaneContainerGrid.rowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.airplaneContainerGrid.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "template",
              { slot: "right" },
              [
                _c(
                  "div",
                  { staticStyle: { float: "right", margin: "10px 0px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "7", type: "primary" },
                        on: { click: _vm.onVesselCostAdd }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "8", type: "danger" },
                        on: { click: _vm.onVesselCostDel }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                    )
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  staticStyle: { height: "100%" },
                  attrs: {
                    no: "9",
                    "config-module": "150010",
                    "grid-options": _vm.costVesselGrid.gridOptions,
                    "column-defs": _vm.costVesselGridColumnDefs,
                    "row-data": _vm.costVesselGrid.rowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.costVesselGrid.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }